import Button from "olive-react-myoneui/lib/Button";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setCart } from "../../reducers/cartSlice";
import RedirectURLObject from "../RedirectURLObject";
import { useTranslation } from "react-i18next";
import { commonModuleName } from "../../constants/config";
import React, { useState, useEffect } from 'react';


function AddToCartButton({ className = false, itemId, itemType = 'course', fromCourseList = false }) {
  const { t } = useTranslation(commonModuleName);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const cartUrlObject = RedirectURLObject({ type: "cart" });
  const isLoggedIn   = useSelector((state) => state.user.user.is_logged_in);
  const [isInCart, setIsInCart] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("mycart") === "[]") localStorage.setItem("mycart", "{}");
    let cart = localStorage.getItem("mycart") !== null ? JSON.parse(localStorage.getItem("mycart")) : {};
    const index = `${itemType}_${itemId}`;
    setIsInCart(typeof cart[index] !== 'undefined');
  }, [itemId, itemType]);
  const postFormDataAsJson = (apiCall, formData) => {
    
    const formDataJsonString = JSON.stringify(formData);
    const fetchOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      body: formDataJsonString,
    };

    const response = fetch(apiCall, fetchOptions)
    .then((response) => response.json())
    // console.log(response,"response")
    //setCartText(true)
    // if (!response.ok) {
    // 	const errorMessage =  response.text();
    // 	throw new Error(errorMessage);
    // }

    // return response.json();
  }

  const cartRedirect = (cartUrlObject) => {
    cartUrlObject.isReact ? navigate(cartUrlObject.url) : window.location.href=cartUrlObject.url;
  }
      
  const addToCartFn = (item = false, id, item_type, learners = {}, other = {}) => {
    let hasOnlyWaitingList = localStorage.getItem('onlyWaitingList') !== 'undefined' && localStorage.getItem('onlyWaitingList') === 'true' ? 1 : 0;
    let cart = hasOnlyWaitingList === 1 ? {} : localStorage.getItem("mycart") !== null ? JSON.parse(localStorage.getItem("mycart")) : {};
    const index = `${item_type}_${id}`;

    if(hasOnlyWaitingList === 1) {
      localStorage.setItem('onlyWaitingList', false)
    }
    if (typeof cart[index] !== "undefined") { 
      cartRedirect(cartUrlObject);
      return false;
    }
    cart[index] = {
      id,
      type: item_type,
      learners,
      metadata: {},
      other,
    };
    const cart_temp = cart[index];
    const cart_count = Object.keys(cart).length;
    localStorage.setItem("mycart", JSON.stringify(cart));
    localStorage.setItem("mycart_count", cart_count);
    const data = {};
    data[index] = cart_temp;
    let current_url = window.location.origin;
    // postFormDataAsJson(current_url+'/cart_react/add_to_cart', data);
    // var isloggedin = localStorage.getItem('cart_user_session');
    // setCartText(true)
    // postFormDataAsJson(current_url + '/api/cart_react/add_to_cart', data);
    if (isLoggedIn) {
      postFormDataAsJson(current_url + '/api/cart_react/add_to_cart', data);
    }
    dispatch(setCart({ cartCount: cart_count }));
    setIsInCart(true);
    if (fromCourseList) {
      // setCartText(true)
      document.querySelectorAll(".cart_btn_" + itemType + "_" + itemId).forEach(elem => elem.innerHTML = t('go_to_cart'));
    }
  };

  const buttonText = isInCart ? t('go_to_cart') : t('add_to_cart');

  return(
    <Button
      variant="outline"
      className={(className !== false ? className : "w-100 mb-3") + " cart_btn_" + itemType + "_" + itemId}
      size="md"
      onClick={() => isInCart ? cartRedirect(cartUrlObject) : addToCartFn(false, itemId, itemType)}
    >
      {buttonText}
    </Button>
  );
}

export default AddToCartButton;
